import React, { useState, useEffect } from 'react';
import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';

const AccordionReusable = ({ rendering, fields }) => {
  // Internal state for open/close
  const [isOpen, setIsOpen] = useState(false);

  // Handle initial open state
  useEffect(() => {
    if (fields.renderOpen?.value) {
      setIsOpen(true);
    }
  }, [fields.renderOpen]);

  // Toggle open/close state
  const toggleItem = () => {
    setIsOpen(!isOpen);
  };

  // Render icon based on open state
  const getIcon = () => {
    if (!fields.iconOpen?.value && !fields.iconClosed?.value) {
      return null;
    }

    return (
      <div className="vds-accordion__icon">
        <i
          data-testid="accordion-icon"
          className={`fa-solid fa-fw fa-${
            isOpen
              ? fields.iconOpen?.value || 'chevron-down'
              : fields.iconClosed?.value || 'chevron-right'
          }`}
        />
      </div>
    );
  };

  return (
    <div
      className={`vds-accordion__item vds-accordion__item--${isOpen ? 'open' : 'closed'}`}
      aria-expanded={isOpen}
    >
      <button
        className="vds-accordion__link"
        type="button"
        data-testid={fields.testid?.value}
        onClick={toggleItem}
      >
        {getIcon()}
        <Text tag="h3" className="vds-accordion__link-inner" field={fields.title} />
        <i className="vds-accordion__item-icon"></i>
      </button>

      <div className="vds-accordion__panel" aria-hidden={!isOpen}>
        <div className="vds-accordion__panel-inner">
          <Placeholder name="accordion-content" rendering={rendering} />
        </div>
      </div>
    </div>
  );
};

export default AccordionReusable;
